export enum ApplicationType {
    MONITORING = 'monitoring',
    PATRIMOINESIM = 'patrimoinesim',
    FLOTTE = 'flotte',
}
